module.exports = __webpack_public_path__ + "img/china-flag.a113333.png";